import React, { useEffect, useState } from "react";
import { FaUser, FaClock, FaPrescription, FaNotesMedical } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import paths from "routes/paths";
import ShimmerUI from "components/ShimmerUI/PatientShimmer";
import { Alert } from "react-bootstrap";

const PatientHistory = () => {
  const [historyObj, setHistoryObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const colChangedMap = {
    doctor_id: "Doctor",
    drug: "Drug",
    dosage: "Dosage",
    route: "Route",
    frequency_id: "Frequency",
    start_date: "Start Date",
    end_date: "End Date",
    client_stopdate: "Stop Date",
    has_vitalsigns: "Has Vital Signs",
    prescriber: "Prescriber",
    notes: "Notes",
    reason_id: "Reason",
    route_id: "Route",
    special_instruction_id: "Special Instruction",
    early: "Early",
    time_between_meds: "Time Between Meds",
    verified_date: "Verified Date",
    medgroup_id: "Med Group",
    drugunit_id: "Drug Unit",
    remaining_refills: "Remaining Refills",
    allergies: "Allergies",
    Prescription: "Prescription",
    Frequency: "Frequency",
    time1: "Time 1",
    time2: "Time 2",
    time3: "Time 3",
    time4: "Time 4",
    time5: "Time 5",
    time6: "Time 6",
    time7: "Time 7",
    time8: "Time 8",
    time_1: "Time 1",
    time_2: "Time 2",
    time_3: "Time 3",
    time_4: "Time 4",
    time_5: "Time 5",
    time_6: "Time 6",
    time_7: "Time 7",
    time_8: "Time 8",
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const tokenString = localStorage.getItem("accessToken");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/patients/patient-history`,
        { patient_id: localStorage.getItem("patientId") },
        { headers: { Authorization: `Bearer ${tokenString}` } }
      );

      if (response.data.status) {
        setHistoryObj(response.data.historyObj);
      } else setError(true);
    } catch (err) {
      console.error("Error fetching:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="timeline p-2">
      {loading ? (
        <ShimmerUI />
      ) : !error && Object.keys(historyObj).length ? (
        Object.entries(historyObj).map(([date, times]) => (
          <div key={date} className="timeline-date-group mb-4">
            <h6
              className="timeline-date fw-bold"
              // style={{ borderLeft: "4px solid #002B5B", paddingLeft: "8px" }}
            >
              {new Date(date).toDateString()}
            </h6>

            {Object.entries(times).map(([time, entities]) => (
              <div key={time} style={{ marginLeft: "16px" }}>
                {/* PATIENT HISTORY */}
                {entities.patient && (
                  <div
                    className="timeline-item d-flex mb-3"
                    style={{
                      alignItems: "flex-start",
                      background: "#F0FAF6",
                      borderRadius: "10px",
                      padding: "12px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    <div
                      className="timeline-icon me-3"
                      style={{
                        color: "#0A6847",
                        background: "#D1FADF",
                        borderRadius: "50%",
                        padding: "6px",
                      }}
                    >
                      <FaUser size={14} />
                    </div>
                    <div className="timeline-content flex-grow-1">
                      <div
                        className="fw-bold"
                        style={{ color: "#0A6847", marginBottom: "4px" }}
                      >
                        Patient record updated
                      </div>
                      {entities.patient.history.map((h) => (
                        <div key={h.id} className="timeline-desc">
                          <span className="fw-semibold">
                            {colChangedMap[h.col_changed] || h.col_changed}
                          </span>
                          {h.old_value ? (
                            <span>
                              {" "}
                              changed from <em>{h.old_value}</em> to{" "}
                              <em>{h.new_value}</em>
                            </span>
                          ) : (
                            <span> set to {h.new_value}</span>
                          )}
                        </div>
                      ))}
                      <div className="text-muted small mt-2">
                        <span>By {entities.patient.history[0]?.updated_by}</span>
                        &nbsp;|&nbsp;
                        <FaClock className="me-1" />
                        {new Date(
                          entities.patient.history[0]?.updated
                        ).toLocaleTimeString()}
                      </div>
                    </div>
                  </div>
                )}

                {/* MEDICAL RECORD HISTORY */}
                {entities.medical_record && (
                  <div
                    className="timeline-item d-flex mb-3"
                    style={{
                      alignItems: "flex-start",
                      background: "#FFF8E7",
                      borderRadius: "10px",
                      padding: "12px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    <div
                      className="timeline-icon me-3"
                      style={{
                        color: "#B45309",
                        background: "#FEF3C7",
                        borderRadius: "50%",
                        padding: "6px",
                      }}
                    >
                      <FaNotesMedical size={14} />
                    </div>
                    <div className="timeline-content flex-grow-1">
                      <div
                        className="fw-bold"
                        style={{ color: "#92400E", marginBottom: "4px" }}
                      >
                        Updated Medical Record ID {entities.medical_record.id}
                      </div>
                      {entities.medical_record.history.map((h) => (
                        <div key={h.id} className="timeline-desc">
                          <span className="fw-semibold">
                            {colChangedMap[h.col_changed] || h.col_changed}
                          </span>
                          {h.old_value ? (
                            <span>
                              {" "}
                              changed from <em>{h.old_value}</em> to{" "}
                              <em>{h.new_value || "—"}</em>
                            </span>
                          ) : (
                            <span> set to {h.new_value || "—"}</span>
                          )}
                        </div>
                      ))}
                      <div className="text-muted small mt-2">
                        <span>
                          By {entities.medical_record.history[0]?.updated_by}
                        </span>
                        &nbsp;|&nbsp;
                        <FaClock className="me-1" />
                        {new Date(
                          entities.medical_record.history[0]?.updated
                        ).toLocaleTimeString()}
                      </div>
                    </div>
                  </div>
                )}

                {/* PRESCRIPTION HISTORY */}
                {entities.prescription &&
                  Object.values(entities.prescription).map((pres) => (
                    <div
                      key={pres.id}
                      className="timeline-item d-flex mb-3"
                      style={{
                        alignItems: "flex-start",
                        background: "#F9FBFF",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      }}
                    >
                      <div
                        className="timeline-icon me-3"
                        style={{
                          color: "#002B5B",
                          background: "#DBEAFE",
                          borderRadius: "50%",
                          padding: "6px",
                        }}
                      >
                        <FaPrescription size={14} />
                      </div>
                      <div className="timeline-content flex-grow-1">
                        <Link
                          to={`${paths.editPrescription}/${pres.id}`}
                          style={{
                            textDecoration: "none",
                            color: "#002B5B",
                            fontWeight: 600,
                            fontSize: "0.95rem",
                          }}
                        >
                          {pres.drug}
                        </Link>

                        {pres.history.map((h) => (
                          <div key={h.id} className="timeline-desc">
                            <span className="fw-semibold">
                              {colChangedMap[h.col_changed] || h.col_changed}
                            </span>
                            {h.old_value ? (
                              <span>
                                {" "}
                                changed from <em>{h.old_value}</em> to{" "}
                                <em>{h.new_value}</em>
                              </span>
                            ) : (
                              <span> set to {h.new_value}</span>
                            )}
                          </div>
                        ))}

                        <div className="text-muted small mt-2">
                          <span>By {pres.history[0]?.updated_by}</span>
                          &nbsp;|&nbsp;
                          <FaClock className="me-1" />
                          {new Date(
                            pres.history[0]?.updated
                          ).toLocaleTimeString()}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        ))
      ) : (
        <Alert variant="info" className="text-center mt-3">
          No Data Found
        </Alert>
      )}
    </div>
  );
};

export default PatientHistory;
